import React, { Component } from "react";
import { connect } from "react-redux";

class StoreInfoOptions extends Component {
  render() {
    const { getInStoreInfoSuccessfully, inStoreInfo } = this.props;
    return (
      <>
        {getInStoreInfoSuccessfully &&
          inStoreInfo.map((store, index) => (
            <option key={index} value={store.storeId}>
              {store.givenName}
            </option>
          ))}
      </>
    );
  }
}

const mapStateToProps = state => ({
  getInStoreInfoSuccessfully: state.pickUpInStore.getInStoreInfoSuccessfully,
  inStoreInfo: state.pickUpInStore.inStoreInfo
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreInfoOptions);
